import React from 'react'
import styles from './styles.module.scss'
import { usePathname, useRouter } from 'next/navigation'
import BackButton from '../back-button/back-button'

interface Props {
    title?: string
    onArrowClick?(): void
}

export default function NavBackTitle(props: Props) {
    const router = useRouter()

    const redirect = () => {
        if (typeof document !== 'undefined' && history.length > 1)
            router.back()
        else
            router.push('/')
    }

    return (
        <div id='nav-title' className={styles.container}>
            <BackButton onClick={() => { props.onArrowClick ? props.onArrowClick() : redirect() }} />
            <h3 className="font-xmd">{props.title ?? 'Voltar'}</h3>
        </div>
    )
}
